/**
 * @flow
 * @relayHash cd26f14fa9d76d04011cb9db7874a182
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type getPropertiesQueryVariables = {|
  orgId: string
|};
export type getPropertiesQueryResponse = {|
  +authorizedSuborgs: $ReadOnlyArray<{|
    +id: string,
    +name: string,
  |}>
|};
export type getPropertiesQuery = {|
  variables: getPropertiesQueryVariables,
  response: getPropertiesQueryResponse,
|};
*/


/*
query getPropertiesQuery(
  $orgId: ID!
) {
  authorizedSuborgs(orgId: $orgId) {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "orgId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "authorizedSuborgs",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orgId",
        "variableName": "orgId"
      }
    ],
    "concreteType": "Suborg",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "getPropertiesQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "getPropertiesQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "getPropertiesQuery",
    "id": null,
    "text": "query getPropertiesQuery(\n  $orgId: ID!\n) {\n  authorizedSuborgs(orgId: $orgId) {\n    id\n    name\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '46b0b57c33be14a5ac69e047f237c147';
module.exports = node;
